<app-topnav></app-topnav>

<div class="top-main-wrapper">


  <div class="dash-header">
    <div class="dash-title">

      <div class="p-field p-grid">
        <div class="p-col-6 p-md-6">
          <h3 class="title-with-count">{{ title }} <span class="total-badge">{{ count() }}</span></h3>
        </div>
        <div class="p-col-6 p-md-6">

          <button pButton pRipple icon="pi pi-plus" [routerLink]="['/admin/users/create']" label=" aggiungi"
          class="p-button p-button-primary -mr-2  pull-right"></button>
          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" labe l="Esporta" (click)="exportPdf()" class="p-button-options p-mr-2 pull-right"  tooltipPosition="bottom"></button> -->

        </div>
      </div>

    </div>
  </div>
</div>



<div class="main-inner">





  <div class="p-fluid">
    <div class="p-field p-grid">
      <div class="p-col-12 p-md-12">

        <app-dynamic-filters [list]="this"></app-dynamic-filters>


            @for ( client of items()  | paginate: { itemsPerPage: pageSize(), currentPage: page(), totalItems: count() }; track  client; let i = $index) {
              <div
                >
              </div>
            }

            <p-table #dt [columns]="cols()" [value]="items()"
              [paginator]="false" [rows]="10">


              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>

                  <td>{{rowData.id}}</td>
                  <td>
                    <h4 class="p-mb-0 p-mt-0 truncate">{{rowData.display_name}}</h4>
                    <p class="small"></p>
                  </td>

                  <td>
                    {{ rowData.u_created_on && !rowData.u_created_on.startsWith('0000') ? (rowData.u_created_on | date) : '-' }}
                  </td>
                  <td>
                    {{rowData.user_email}}
                  </td>

                  <td>

                    @if (rowData.account_type == 2) {
                      <p-tag severity="default">Pro</p-tag>
                    }

                  </td>


                  <td>
                    @if (rowData.is_active == 1) {
                      <p-tag severity="success">active</p-tag>
                    }

                    @if (rowData.is_active == 0) {
                      <p-tag severity="danger">not active</p-tag>
                    }

                  </td>
                  <td class="action">
                    <button pButton pRipple icon="pi pi-trash"
                      class="p-button p-button-danger pull-right p-mr-2"
                    (click)="onDelete(rowData.id)"></button>
                    <button pButton pRipple icon="pi pi-pencil"
                      class="p-button p-button-success pull-right p-mr-2"
                    [routerLink]="['/admin/users/edit', rowData.id]"></button>
                    <button pButton pRipple icon="pi pi-eye"
                      class="p-button p-button-primary pull-right p-mr-2"
                    (click)="edit(rowData)"></button>

                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="p-grid">
              <div class="p-col-12 p-md-4">
                <p class="p-pt-1">
                  <span class="count-item pull-left">{{pageSize() * page() - pageSize() +1 }} - {{pageSize() * page()}}
                  di {{count()}} risultati</span>
                </p>
              </div>
              <div class="p-col-12 p-md-8">
                <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true"
                  (pageChange)="handlePageChange($event)">
                </pagination-controls>
              </div>
            </div>

          </div>


        </div>
      </div>

    </div>




      <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>

        <p-footer>
          <button type="button" pButton icon="fa fa-close" class="p-button p-button-danger p-mr-2" label="No"
          (click)="cd.reject()"></button>
          <button type="button" pButton icon="fa fa-check" class="p-button p-button-success p-mr-2" label="Si"
          (click)="cd.accept()"></button>
        </p-footer>

      </p-confirmDialog>

      <p-toast key="myKey1"></p-toast>

      <p-toast key="myKey2">{{error()}}</p-toast>